<template>
  <div style='overflow:visible'>
    <!--
    <div class="bg-white max-w-sm rounded overflow-hidden shadow-lg flex" style='overflow:visible'>
    -->
      <multiselect v-model='selection' 
        class="my-auto text-xs"
        :options='vars'
        :option-height='20'
        :multiple='false'
        :taggable='false'
        label='variable.name'
        track-by='variable.id'
        :show-labels="false"
        placeholder='Select variable'>
      <template slot="singleLabel" slot-scope="props">
        <div class="text-xs">{{props.option.name}}</div>
      </template>
      <template slot="option" slot-scope="props">
        <div class="text-xs">
        </div>
        {{ props.option.name }}
      </template>

      </multiselect>
      <!--
    </div>
      -->
  </div>

</template>
<script>
import Multiselect from 'vue-multiselect'
export default {
  props:{
    value:{
      required:true
    },
    variables:{
      type:Array,
      required:true
    }
  },
  data() {
    return {
      selection: this.value
    }
  },
  components:{
    Multiselect
  },
  methods:{
    getIcon({variable}) {
    },
    getClass({variable}) {
    }
  },
  computed:{
    vars() {
      return this.variables.map( ({variable}) => {
        return variable;
      });
    }
  },
  watch:{
    selection(nv) {
      console.log('selection',nv);
      this.$emit('input', nv);
    }
  }

}
</script>
<style>
</style>

